import React, { useEffect, useState } from 'react';

// Session-scoped splash: shown ONLY on the first mount of a browser session
// (cold-start / new tab / reopened PWA). We use sessionStorage so that:
//   - full page reload in the same tab → NO splash
//   - login / logout / SPA navigation → NO splash
//   - closing the tab or PWA and reopening → splash again
const STORAGE_KEY = 'ww_splash_seen';

const Splash = () => {
  const [visible, setVisible] = useState(() => {
    try { return sessionStorage.getItem(STORAGE_KEY) !== '1'; }
    catch { return true; }
  });

  useEffect(() => {
    if (!visible) return;
    try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch {}
    const t = setTimeout(() => setVisible(false), 3000);
    return () => clearTimeout(t);
  }, [visible]);

  if (!visible) return null;

  return (
    <div className="splash-root" data-testid="splash-screen">
      {/* Circular crop matches the Android launch screen, which masks the
          "any maskable" manifest icon to a circle (~87% of the image). */}
      <div className="splash-logo">
        <img
          src="/wallweek-logo-1024.png"
          srcSet="/wallweek-logo-512.png 1x, /wallweek-logo-1024.png 2x, /wallweek-logo-2048.png 3x"
          alt="Wall Week"
          className="splash-logo-img"
          draggable={false}
        />
      </div>
      <p className="splash-tagline">Cosa succede oggi nel tuo paese?</p>
    </div>
  );
};

export default Splash;
